import api from './utilPartner';

const controller = 'PessoaBensMoveis';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  ListarPorPessoa: function (dto) {
    return api.Axios.GetParams(url + '/ListarPorPessoa', dto);
  }
});
